import bakirAvif from '../assets/products/bakir.avif';
import bakirPng from '../assets/products/bakir.png';
import bakirWebp from '../assets/products/bakir.webp';

import pirincAvif from '../assets/products/pirinc.avif';
import pirincPng from '../assets/products/pirinc.png';
import pirincWebp from '../assets/products/pirinc.webp';

import aluminyumAvif from '../assets/products/aluminyum.avif';
import aluminyumPng from '../assets/products/aluminyum.png';
import aluminyumWebp from '../assets/products/aluminyum.webp';

import bronzBoruAvif from '../assets/products/bronz-boru.avif';
import bronzBoruPng from '../assets/products/bronz-boru.png';
import bronzBoruWebp from '../assets/products/bronz-boru.webp';

import aluminyumCubukavif from '../assets/products/aluminyum-cubuk.avif';
import aluminyumCubukPng from '../assets/products/aluminyum-cubuk.png';
import aluminyumCubukWebp from '../assets/products/aluminyum-cubuk.webp';

import aluminyumLevhaAvif from '../assets/products/aluminyum-levha.avif';
import aluminyumLevhaPng from '../assets/products/aluminyum-levha.png';
import aluminyumLevhaWebp from '../assets/products/aluminyum-levha.webp';

import aluminyumLamaAvif from '../assets/products/aluminyum-lama.avif';
import aluminyumLamaPng from '../assets/products/aluminyum-lama.png';
import aluminyumLamaWebp from '../assets/products/aluminyum-lama.webp';

import aluminyumKareCubukAvif from '../assets/products/aluminyum-kare-cubuk.avif';
import aluminyumKareCubukPng from '../assets/products/aluminyum-kare-cubuk.png';
import aluminyumKareCubukWebp from '../assets/products/aluminyum-kare-cubuk.webp';

import bronzCubukAvif from '../assets/products/bronz-cubuk.avif';
import bronzCubukPng from '../assets/products/bronz-cubuk.png';
import bronzCubukWebp from '../assets/products/bronz-cubuk.webp';

import pirincLevhaAvif from '../assets/products/pirinc-levha.avif';
import pirincLevhaPng from '../assets/products/pirinc-levha.png';
import pirincLevhaWebp from '../assets/products/pirinc-levha.webp';

import pirincLamaAvif from '../assets/products/pirinc-lama.avif';
import pirincLamaPng from '../assets/products/pirinc-lama.png';
import pirincLamaWebp from '../assets/products/pirinc-lama.webp';

import pirincKaynakTeliAvif from '../assets/products/pirinc-kaynak-teli.avif';
import pirincKaynakTeliPng from '../assets/products/pirinc-kaynak-teli.png';
import pirincKaynakTeliWebp from '../assets/products/pirinc-kaynak-teli.webp';

import pirincCubukAvif from '../assets/products/pirinc-cubuk.avif';
import pirincCubukPng from '../assets/products/pirinc-cubuk.png';
import pirincCubukWebp from '../assets/products/pirinc-cubuk.webp';

import pirincAltikoseCubukAvif from '../assets/products/pirinc-altikose-cubuk.avif';
import pirincAltikoseCubukPng from '../assets/products/pirinc-altikose-cubuk.png';
import pirincAltikoseCubukWebp from '../assets/products/pirinc-altikose-cubuk.webp';

import pirincKareCubukAvif from '../assets/products/pirinc-kare-cubuk.avif';
import pirincKareCubukPng from '../assets/products/pirinc-kare-cubuk.png';
import pirincKareCubukWebp from '../assets/products/pirinc-kare-cubuk.webp';

import bakirBoruAvif from '../assets/products/bakir-boru.avif';
import bakirBoruPng from '../assets/products/bakir-boru.png';
import bakirBoruWebp from '../assets/products/bakir-boru.webp';

import bakirCubukAvif from '../assets/products/bakir-cubuk.avif';
import bakirCubukPng from '../assets/products/bakir-cubuk.png';
import bakirCubukWebp from '../assets/products/bakir-cubuk.webp';

import bakirKangalBoruAvif from '../assets/products/bakir-kangal-boru.avif';
import bakirKangalBoruPng from '../assets/products/bakir-kangal-boru.png';
import bakirKangalBoruWebp from '../assets/products/bakir-kangal-boru.webp';

import bakirKaynakTeliAvif from '../assets/products/bakir-kaynak-teli.avif';
import bakirKaynakTeliPng from '../assets/products/bakir-kaynak-teli.png';
import bakirKaynakTeliWebp from '../assets/products/bakir-kaynak-teli.webp';

import bakirLamaAvif from '../assets/products/bakir-lama.avif';
import bakirLamaPng from '../assets/products/bakir-lama.png';
import bakirLamaWebp from '../assets/products/bakir-lama.webp';

import bakirLevhaAvif from '../assets/products/bakir-levha.avif';
import bakirLevhaPng from '../assets/products/bakir-levha.png';
import bakirLevhaWebp from '../assets/products/bakir-levha.webp';

import bakirKareCubukAvif from '../assets/products/bakir-kare-cubuk.avif';
import bakirKareCubukPng from '../assets/products/bakir-kare-cubuk.png';
import bakirKareCubukWebp from '../assets/products/bakir-kare-cubuk.webp';

import bakirSeritAvif from '../assets/products/bakir-serit.avif';
import bakirSeritPng from '../assets/products/bakir-serit.png';
import bakirSeritWebp from '../assets/products/bakir-serit.webp';

import baralikAvif from '../assets/products/baralik-ve-topraklamalik-malzeme.avif';
import baralikPng from '../assets/products/baralik-ve-topraklamalik-malzeme.png';
import baralikWebp from '../assets/products/baralik-ve-topraklamalik-malzeme.webp';

export const productCategoriesData: ProductCategories = {
  categoryName1: {
    key: 1,
    name: 'categoryName1',
    title: 'menuProductsSubTitle1',
    url: 'pathMenuProductsSubTitle1',
    imageUrl: `${bakirPng}`,
    webpImage: `${bakirWebp}`,
    avifImage: `${bakirAvif}`,
    article: 'productCategoryCopper',
    products: [
      {
        active: true,
        key: 1,
        title: 'copperProduct1',
        description: 'copperProduct1Description',
        url: 'pathMenuProductsSubTitle1Option1',
        imageUrl: `${bakirBoruPng}`,
        webpImage: `${bakirBoruWebp}`,
        avifImage: `${bakirBoruAvif}`,
      },
      {
        active: false,
        key: 2,
        title: 'copperProduct2',
        description: 'copperProduct2Description',
        url: 'pathMenuProductsSubTitle1Option2',
        imageUrl: `${bakirCubukPng}`,
        webpImage: `${bakirCubukWebp}`,
        avifImage: `${bakirCubukAvif}`,
      },
      {
        active: false,
        key: 3,
        title: 'copperProduct3',
        description: 'copperProduct3Description',
        url: 'pathMenuProductsSubTitle1Option3',
        imageUrl: `${bakirKareCubukPng}`,
        webpImage: `${bakirKareCubukWebp}`,
        avifImage: `${bakirKareCubukAvif}`,
      },
      {
        active: true,
        key: 4,
        title: 'copperProduct4',
        description: 'copperProduct4Description',
        url: 'pathMenuProductsSubTitle1Option4',
        imageUrl: `${bakirKangalBoruPng}`,
        webpImage: `${bakirKangalBoruWebp}`,
        avifImage: `${bakirKangalBoruAvif}`,
      },
      {
        active: false,
        key: 5,
        title: 'copperProduct5',
        description: 'copperProduct5Description',
        url: 'pathMenuProductsSubTitle1Option5',
        imageUrl: `${bakirKaynakTeliPng}`,
        webpImage: `${bakirKaynakTeliWebp}`,
        avifImage: `${bakirKaynakTeliAvif}`,
      },
      {
        active: true,
        key: 6,
        title: 'copperProduct6',
        description: 'copperProduct6Description',
        url: 'pathMenuProductsSubTitle1Option6',
        imageUrl: `${bakirLamaPng}`,
        webpImage: `${bakirLamaWebp}`,
        avifImage: `${bakirLamaAvif}`,
      },
      {
        active: true,
        key: 7,
        title: 'copperProduct7',
        description: 'copperProduct7Description',
        url: 'pathMenuProductsSubTitle1Option7',
        imageUrl: `${bakirLevhaPng}`,
        webpImage: `${bakirLevhaWebp}`,
        avifImage: `${bakirLevhaAvif}`,
      },
      {
        active: true,
        key: 8,
        title: 'copperProduct8',
        description: 'copperProduct8Description',
        url: 'pathMenuProductsSubTitle1Option8',
        imageUrl: `${bakirSeritPng}`,
        webpImage: `${bakirSeritWebp}`,
        avifImage: `${bakirSeritAvif}`,
      },
      {
        active: true,
        key: 9,
        title: 'copperProduct9',
        description: 'copperProduct9Description',
        url: 'pathMenuProductsSubTitle1Option9',
        imageUrl: `${baralikPng}`,
        webpImage: `${baralikWebp}`,
        avifImage: `${baralikAvif}`,
      },
    ],
  },
  categoryName2: {
    key: 2,
    name: 'categoryName2',
    title: 'menuProductsSubTitle2',
    url: 'pathMenuProductsSubTitle2',
    imageUrl: `${pirincPng}`,
    webpImage: `${pirincWebp}`,
    avifImage: `${pirincAvif}`,
    article: 'productCategoryBrass',
    products: [
      {
        active: true,
        key: 1,
        title: 'brassProduct1',
        description: 'brassProduct1Description',
        url: 'pathMenuProductsSubTitle2Option1',
        imageUrl: `${pirincCubukPng}`,
        webpImage: `${pirincCubukWebp}`,
        avifImage: `${pirincCubukAvif}`,
      },
      {
        active: false,
        key: 2,
        title: 'brassProduct2',
        description: 'brassProduct2Description',
        url: 'pathMenuProductsSubTitle2Option2',
        imageUrl: `${pirincAltikoseCubukPng}`,
        webpImage: `${pirincAltikoseCubukWebp}`,
        avifImage: `${pirincAltikoseCubukAvif}`,
      },
      {
        active: false,
        key: 3,
        title: 'brassProduct3',
        description: 'brassProduct3Description',
        url: 'pathMenuProductsSubTitle2Option3',
        imageUrl: `${pirincKareCubukPng}`,
        webpImage: `${pirincKareCubukWebp}`,
        avifImage: `${pirincKareCubukAvif}`,
      },
      {
        active: false,
        key: 4,
        title: 'brassProduct4',
        description: 'brassProduct4Description',
        url: 'pathMenuProductsSubTitle2Option4',
        imageUrl: `${pirincKaynakTeliPng}`,
        webpImage: `${pirincKaynakTeliWebp}`,
        avifImage: `${pirincKaynakTeliAvif}`,
      },
      {
        active: true,
        key: 5,
        title: 'brassProduct5',
        description: 'brassProduct5Description',
        url: 'pathMenuProductsSubTitle2Option5',
        imageUrl: `${pirincLamaPng}`,
        webpImage: `${pirincLamaWebp}`,
        avifImage: `${pirincLamaAvif}`,
      },
      {
        active: false,
        key: 6,
        title: 'brassProduct6',
        description: 'brassProduct6Description',
        url: 'pathMenuProductsSubTitle2Option6',
        imageUrl: `${pirincLevhaPng}`,
        webpImage: `${pirincLevhaWebp}`,
        avifImage: `${pirincLevhaAvif}`,
      },
    ],
  },
  categoryName3: {
    key: 3,
    name: 'categoryName3',
    title: 'menuProductsSubTitle3',
    url: 'pathMenuProductsSubTitle3',
    imageUrl: `${aluminyumPng}`,
    webpImage: `${aluminyumWebp}`,
    avifImage: `${aluminyumAvif}`,
    article: 'productCategoryAluminum',
    products: [
      {
        active: true,
        key: 1,
        title: 'aluminumProduct1',
        description: 'aluminumProduct1Description',
        url: 'pathMenuProductsSubTitle3Option1',
        imageUrl: `${aluminyumCubukPng}`,
        webpImage: `${aluminyumCubukWebp}`,
        avifImage: `${aluminyumCubukavif}`,
      },
      {
        active: false,
        key: 2,
        title: 'aluminumProduct2',
        description: 'aluminumProduct2Description',
        url: 'pathMenuProductsSubTitle3Option2',
        imageUrl: `${aluminyumKareCubukPng}`,
        webpImage: `${aluminyumKareCubukWebp}`,
        avifImage: `${aluminyumKareCubukAvif}`,
      },
      {
        active: true,
        key: 3,
        title: 'aluminumProduct3',
        description: 'aluminumProduct3Description',
        url: 'pathMenuProductsSubTitle3Option3',
        imageUrl: `${aluminyumLamaPng}`,
        webpImage: `${aluminyumLamaWebp}`,
        avifImage: `${aluminyumLamaAvif}`,
      },
      {
        active: true,
        key: 4,
        title: 'aluminumProduct4',
        description: 'aluminumProduct4Description',
        url: 'pathMenuProductsSubTitle3Option4',
        imageUrl: `${aluminyumLevhaPng}`,
        webpImage: `${aluminyumLevhaWebp}`,
        avifImage: `${aluminyumLevhaAvif}`,
      },
    ],
  },
  categoryName4: {
    key: 4,
    name: 'categoryName4',
    title: 'menuProductsSubTitle4',
    url: 'pathMenuProductsSubTitle4',
    imageUrl: `${bronzBoruPng}`,
    webpImage: `${bronzBoruWebp}`,
    avifImage: `${bronzBoruAvif}`,
    article: 'productCategoryBronze',
    products: [
      {
        active: true,
        key: 1,
        title: 'bronzeProduct1',
        description: 'bronzeProduct1Description',
        url: 'pathMenuProductsSubTitle4Option1',
        imageUrl: `${bronzCubukPng}`,
        webpImage: `${bronzCubukWebp}`,
        avifImage: `${bronzCubukAvif}`,
      },
    ],
  },
};

export interface Product {
  key: number;
  active: boolean;
  title: string;
  description: string;
  url: string;
  imageUrl: string;
  webpImage: string;
  avifImage?: string;
}

export interface Category {
  key: number;
  name: string;
  title: string;
  url: string;
  imageUrl: string;
  webpImage: string;
  avifImage?: string;
  article: string;
  products: Product[];
}

export interface ProductCategories {
  [key: string]: Category;
}
